import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/theme";
import Header from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/components/Header";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

const Companies = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();

  // Fetch companies
  const fetchCompanies = () => {
    axiosInstance
      .get("/companies")
      .then((res) => setCompanies(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchCompanies();
  }, []);
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Company Name", flex: 1 },

    // Promoter
    {
      field: "promoter",
      headerName: "Promoter",
      width: 120,
      renderCell: ({ row }) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => navigate(`/companies/${row.id}/promoters`)}
        >
          View
        </Button>
      ),
    },

    // Terminologies
    {
      field: "terminologies",
      headerName: "Terminologies",
      width: 150,
      renderCell: ({ row }) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => navigate(`/companies/${row.id}/terminologies`)}
        >
          View
        </Button>
      ),
    },

    // Product
    {
      field: "product",
      headerName: "Product",
      width: 120,
      renderCell: ({ row }) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => navigate(`/companies/${row.id}/products`)}
        >
          View
        </Button>
      ),
    },

    // Policy
    {
      field: "policy",
      headerName: "Policy",
      width: 120,
      renderCell: ({ row }) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => navigate(`/companies/${row.id}/policies`)}
        >
          View
        </Button>
      ),
    },

    // Plans
    {
      field: "plans",
      headerName: "Plans",
      width: 120,
      renderCell: ({ row }) => (
        <Button
          size="small"
          color="secondary"
          onClick={() => navigate(`/companies/${row.id}/plans`)}
        >
          View
        </Button>
      ),
    },

    // Edit action
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: ({ row }) => (
        <IconButton
          color="primary"
          onClick={() => navigate(`/companies/edit/${row.id}`)}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="COMPANIES" subtitle="List of all companies" />

      {/* Add New Company Button */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/companies/add")}
        >
          Add New Company
        </Button>
      </Box>

      <Box
        m="0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        <DataGrid
          rows={companies}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
        />
      </Box>
    </Box>
  );
};

export default Companies;
